// HospitalPage.js
import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import StickyHeader from "../../components/StickyHeader";
import StickyFooter from "../../components/StickyFooter";
import "../../css/dedails.css";
function EnergyManageSystem() {
  useEffect(() => {
    AOS.init({
      duration: 800, // 缩短动画时间使响应更快
      once: false, // 允许重复触发动画
      offset: 100,
      easing: "ease-out-cubic", // 添加缓动效果
      delay: 0,
      mirror: true, // 页面滚动时反向动画
    });
  }, []);
  return (
    <div className="home-container">
      <StickyHeader />
      <div className="main-content">
       
        <div style={{ minHeight: "800px" }}>
          {/* 第一个盒子 - 产 品 介 绍 */}
          <div className="top1s1p animated-section">
            <Container>
              <div className="box">
                <div className="top">
                  <div className="noe1" data-aos="fade-down">
                    <span className="h1">桐城市工商联各级领导莅临指导</span>
                    <p>
                      2025-07-23
                    </p>
                  </div>
                  <div className="boxnosl">
                   
                     <div className="titlebox">
                     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;桐城市工商联各级领导莅临指导：2025年7月23日，桐城市工商业联合会（简称“工商联”）一行莅临安徽合利电气股份有限公司开展调研指导工作。此次走访旨在深入了解企业发展现状，倾听企业诉求，搭建政企沟通桥梁，助力民营企业高质量发展。
桐城市工商联对我公司在推动产业升级、带动就业、履行社会责任等方面取得的成绩给予充分肯定。他指出，民营企业是推动经济高质量发展的主力军，工商联作为党和政府联系非公有制经济人士的桥梁纽带，聚焦企业关切，强化服务保障，切实帮助企业纾困解难、提振信心。
                    </div>
                    <img
                        src={`${process.env.PUBLIC_URL}/imgs/2w.png`}
                        alt="" 
                        className="image-hoverss"
                      />
                   
                   
                  
                  </div>
                </div>
              </div>
            </Container>
          </div>

         

        
          
        </div>
      </div>

      <StickyFooter />
    </div>
  );
}

export default EnergyManageSystem;
